import EmptyStates from 'component/EmptyStates/EmptyStates'
import GenericObjectCard from 'component/GenericObjectCard'
import { useTranslation } from 'react-i18n-lite'
import { DataCardsButtonProps } from 'site/Renderer/components/DataCards/DataCards.types'
import { FilteredItemsProps } from '../../FilterableMap.types'
import FilteredObjectButton from './FilteredObjectButton'
import {
  CardsContainer,
  EmptyStatesContainer,
  FilteredObjectSkeletonDots
} from './styles'

export const PAID_STANDARD = 'paid_standard'

export type FilteredObjectsProps = {
  objects: FilteredItemsProps[]
  target?: '_self' | '_blank'
  actionColor?: string
  buttonProps?: DataCardsButtonProps
  isLoading?: boolean
}

const FilteredObjects = ({
  objects,
  target = '_blank',
  actionColor = '#006bff',
  buttonProps,
  isLoading = false
}: FilteredObjectsProps) => {
  const { t } = useTranslation()

  const publicButtonProps =
    buttonProps?.type === 'public' ? buttonProps : undefined

  return (
    <>
      {isLoading || !objects?.length ? (
        <EmptyStatesContainer $color={actionColor}>
          {!isLoading && !objects.length ? (
            <EmptyStates state='no-results-found' showComplement />
          ) : (
            <FilteredObjectSkeletonDots data-testid='skeleton-dots' />
          )}
        </EmptyStatesContainer>
      ) : (
        <CardsContainer role='list'>
          {objects.map(({ complement, des, uuid, documento }) => {
            const isPaidStandard = documento?.[0]?.des === PAID_STANDARD

            const documentButtonLabel = isPaidStandard
              ? t('filterable-map.paid-standard')
              : t('filterable-map.document-label')

            const documentUrl = documento?.[0]?.des

            return (
              <div key={uuid} role='listitem'>
                <GenericObjectCard
                  complement={complement}
                  des={des}
                  CustomAction={
                    <FilteredObjectButton
                      href={documentUrl}
                      label={documentButtonLabel}
                      target={target}
                      buttonProps={publicButtonProps}
                      isDisabled={isPaidStandard}
                      style={
                        !publicButtonProps
                          ? {
                              color: actionColor,
                              borderColor: actionColor
                            }
                          : undefined
                      }
                    />
                  }
                />
              </div>
            )
          })}
        </CardsContainer>
      )}
    </>
  )
}

export default FilteredObjects
